import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

new Swiper(".price-type", {
    modules: [FreeMode],
    slidesPerView: 'auto'
});
